import React from "react"
import { Text, Flex } from "@chakra-ui/react"
import { Link } from "components/Link"

export const CList: React.FC = () => {
  return (
    <>
      <Text variant="acuminLight" mt={0}>
        This product appears on a curated list of the best picks for skincare,
        haircare and cosmetics for cancer treatment sensitised skin, WITHOUT
        skin renewing retinoids, Alpha/Beta Hydroxy Acids, or fragrance. (Of
        course, many BEAUTY PIE products don’t contain these items, but as we
        are very active ingredient focused, most contain ‘some’.)
        <br /> <br /> Learn more about {` `}
        <Link
          variant="acuminLight"
          textDecoration="underline"
          href="/blog/in-conversation-with-helen-addis"
        >
          The C-List
        </Link>
      </Text>

      <Flex direction="column" mt={3}>
        <Text variant="acuminCapsM1" mt={0}>
          Disclaimer
        </Text>
        <Text variant="acuminLight" mt={-1}>
          We have worked hard to curate a selection of products suitable for
          sensitive and sensitised skin that are free from retinoids,
          alpha-hydroxy acids, beta-hydroxy acids and fragrance. However
          individual responses to cancer treatments can vary quite widely and
          your body may not take to every product. We therefore always recommend
          consulting with your medical practitioner if you experience any skin
          issues or discomfort. The products offered here are not medical
          products.
        </Text>
      </Flex>
    </>
  )
}
